module.exports = __webpack_public_path__ + "img/item3-3.104d6a8d.jpg";